module.exports = require('./$.global');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.path.js
// module id = 2363
// module chunks = 0